import React, { useState } from 'react';
import { Alert, Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material';
import Looks3Icon from '@mui/icons-material/Looks3';
import { DropzoneDialog } from 'mui-file-dropzone';
import {
  AftermarketProductDocumentsResponse,
  AftermarketProductDocumentsVariables,
  ProductPageDocumentsState,
} from 'modules/aftermarket';
import { DocumentsList } from './DocumentsList';
import { useQuery } from '@apollo/client';
import { aftermarketProductsApi } from '../../api';

interface Props {
  canWrite: boolean;
  documents: ProductPageDocumentsState;
  aftermarketProductId: string | undefined;
  setDocuments: (documents: ProductPageDocumentsState) => void;
}

export const DocumentsCard = ({ aftermarketProductId, canWrite, documents, setDocuments }: Props) => {
  useQuery<AftermarketProductDocumentsResponse, AftermarketProductDocumentsVariables>(
    aftermarketProductsApi.getDocumentsByAftermarketProductId,
    {
      skip: !aftermarketProductId,
      variables: {
        aftermarketProductId: aftermarketProductId!,
      },
      onCompleted(data) {
        setDocuments({
          ...documents,
          initialDocuments: data.aftermarketProductDocuments,
        });
      },
    }
  );

  const [isDropzoneDialogOpen, setIsDropzoneDialogOpen] = useState<boolean>(false);

  const handleSaveFiles = (files: File[]) => {
    setDocuments({ ...documents, documentsToAdd: [...documents.documentsToAdd, ...files] });
    setIsDropzoneDialogOpen(false);
  };

  return (
    <>
      <Card variant="outlined" sx={{ padding: '1rem' }}>
        <CardHeader
          sx={{ padding: 0 }}
          title={
            <Typography variant="subtitle1" color="primary">
              <Looks3Icon /> Product Attachments
            </Typography>
          }
        />

        <CardContent>
          {documents.initialDocuments.length === 0 && documents.documentsToAdd.length === 0 ? (
            <Alert severity="info">No Attachments</Alert>
          ) : (
            <DocumentsList canWrite={canWrite} documents={documents} setDocuments={setDocuments} />
          )}
        </CardContent>

        <CardActions>
          <Button variant="contained" disabled={!canWrite} onClick={() => setIsDropzoneDialogOpen(true)} size="small">
            Attach Document
          </Button>
        </CardActions>
      </Card>

      <DropzoneDialog
        fileObjects={[]}
        onSave={handleSaveFiles}
        cancelButtonText="cancel"
        submitButtonText="submit"
        open={isDropzoneDialogOpen}
        acceptedFiles={['application/pdf']}
        onClose={() => setIsDropzoneDialogOpen(false)}
      />
    </>
  );
};
